// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"8230737a692b0fea","4882":"f015c1dba207fbb7","8180":"f015c1dba207fbb7"}[chunkId] + ".css";
};